import { Link } from "react-router-dom";
import { Button } from "../components/ui/button";
import { ArrowRight, Truck, Shield, Clock, Award } from "lucide-react";

const HERO_BG = "https://images.unsplash.com/photo-1610018924075-558aa6b0d7a9?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA3MDR8MHwxfHNlYXJjaHwzfHxjb25jcmV0ZSUyMGFyY2hpdGVjdHVyZSUyMG1vZGVybnxlbnwwfHx8fDE3NzQ2MDc1NDl8MA&ixlib=rb-4.1.0&q=85";
const ABOUT_IMG = "https://images.pexels.com/photos/4956920/pexels-photo-4956920.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940";
const MIXER_IMG = "https://images.unsplash.com/photo-1705382063926-e26ac23ecf4e?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NTYxODl8MHwxfHNlYXJjaHwyfHxjb25jcmV0ZSUyMG1peGVyJTIwdHJ1Y2t8ZW58MHx8fHwxNzc0NjA3NTQ4fDA&ixlib=rb-4.1.0&q=85";

const concreteGrades = [
  { grade: "C8/10 (B150)", description: "Beton de egalizare", price: "360" },
  { grade: "C12/15 (B200)", description: "Fundații case", price: "385" },
  { grade: "C16/20 (B250)", description: "Plăci, trotuare", price: "405" },
  { grade: "C18/22.5 (B300)", description: "Structuri ușoare", price: "425" },
  { grade: "C20/25 (B350)", description: "Structuri rezidențiale", price: "445" },
  { grade: "C25/30 (B400)", description: "Structuri industriale", price: "460" },
  { grade: "C30/37 (B450)", description: "Construcții speciale", price: "485" },
  { grade: "C32/40 (B500)", description: "Infrastructură", price: "520" },
  { grade: "C35/45 (B550)", description: "Proiecte complexe", price: "535" },
  { grade: "C40/50 (B600)", description: "Construcții grele", price: "725" },
  { grade: "Șapă M100", description: "Șapă autonivelantă", price: "440" },
];

const testimonials = [
  {
    quote: "Calitate excelentă și livrare la timp. Recomand cu încredere Solar Construct pentru orice proiect de construcții.",
    author: "Ion Popescu",
    company: "Constructor PFA",
  },
  {
    quote: "Colaborăm de peste 5 ani. Betonul lor a fost perfect pentru toate proiectele noastre rezidențiale.",
    author: "Maria Ionescu",
    company: "Ionescu Construcții SRL",
  },
  {
    quote: "Servicii profesionale și prețuri competitive. Echipa Solar Construct este de încredere.",
    author: "Andrei Vasilescu",
    company: "Vasilescu & Asociații",
  },
];

const features = [
  {
    icon: Truck,
    title: "Livrare Rapidă",
    description: "Transport cu autobetoniere moderne în toată regiunea Vrancea",
  },
  {
    icon: Shield,
    title: "Calitate Garantată",
    description: "Beton certificat, testat în laborator autorizat",
  },
  {
    icon: Clock,
    title: "Program Flexibil",
    description: "Luni - Sambata, 07:30 - 16:30, livrări la comandă",
  },
  {
    icon: Award,
    title: "Experiență",
    description: "Peste 24 ani de experiență în industria construcțiilor",
  },
];

const partners = [
  {
    name: "Heidelberg Materials",
    logo: "https://customer-assets.emergentagent.com/job_sc-solar-ro/artifacts/zlgnj6fa_HeidelbergMaterials.svg",
  },
  {
    name: "Holcim",
    logo: "https://customer-assets.emergentagent.com/job_sc-solar-ro/artifacts/iugp1xoi_holcim_logo_color.svg",
  },
  {
    name: "ROMCIM",
    logo: "https://customer-assets.emergentagent.com/job_sc-solar-ro/artifacts/gh0e5cin_ROMCIM%20LOGO.svg",
  },
  {
    name: "Prodcombilc",
    logo: "https://customer-assets.emergentagent.com/job_sc-solar-ro/artifacts/6r2cd5ez_prodcombilc.png",
  },
  {
    name: "SICOR",
    logo: "https://customer-assets.emergentagent.com/job_sc-solar-ro/artifacts/t5r8ywk4_SICOR1.avif",
  },
  {
    name: "RALCODI",
    logo: "https://customer-assets.emergentagent.com/job_sc-solar-ro/artifacts/gwptckpd_logo-pieseconstructii.png",
  },
];

export const Home = () => {
  return (
    <div data-testid="home-page">
      {/* Hero Section */}
      <section 
        className="relative min-h-screen flex items-center"
        style={{
          backgroundImage: `url(${HERO_BG})`,
          backgroundSize: "cover",
          backgroundPosition: "center",
        }}
        data-testid="hero-section"
      >
        <div className="absolute inset-0 bg-black/60" />
        <div className="relative z-10 px-6 md:px-12 lg:px-24 py-32 pt-40">
          <div className="max-w-3xl">
            <p className="text-xs font-bold tracking-[0.2em] uppercase text-[#FACC15] mb-4">
              SC SOLAR CONSTRUCT SRL
            </p>
            <h1 className="text-5xl sm:text-6xl lg:text-7xl font-black tracking-tighter uppercase text-white mb-6 leading-none">
              BETON DE<br />CALITATE<br />SUPERIOARĂ
            </h1>
            <p className="text-lg text-white/80 mb-8 max-w-xl font-medium leading-relaxed">
              Furnizăm beton readymix de înaltă calitate pentru toate tipurile de proiecte de construcții din regiunea Focșani și împrejurimi.
            </p>
            <div className="flex flex-col sm:flex-row gap-4">
              <Button 
                asChild
                className="bg-[#FACC15] text-[#0A0A0A] hover:bg-yellow-400 rounded-none font-bold tracking-wider uppercase text-sm px-8 py-6"
                data-testid="hero-cta-btn"
              >
                <Link to="/servicii">
                  Vezi Prețurile
                  <ArrowRight className="ml-2 w-4 h-4" />
                </Link>
              </Button>
              <Button 
                asChild
                variant="outline"
                className="bg-transparent border-2 border-white text-white hover:bg-white hover:text-[#0A0A0A] rounded-none font-bold tracking-wider uppercase text-sm px-8 py-6"
                data-testid="hero-contact-btn"
              >
                <Link to="/contact">Contactează-ne</Link>
              </Button>
            </div>
          </div>
        </div>
      </section>

      {/* Features Section */}
      <section className="py-24 md:py-32 bg-white border-b border-[#D4D4D4]" data-testid="features-section">
        <div className="px-6 md:px-12 lg:px-24">
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
            {features.map((feature, index) => (
              <div 
                key={index} 
                className="p-8 border border-[#D4D4D4] hover:border-[#FACC15] transition-colors"
                data-testid={`feature-${index}`}
              >
                <feature.icon className="w-10 h-10 text-[#FACC15] mb-4" />
                <h3 className="text-xl font-bold mb-2">{feature.title}</h3>
                <p className="text-[#737373] text-sm">{feature.description}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Partners Section */}
      <section className="py-16 bg-[#0A0A0A]" data-testid="partners-section">
        <div className="px-6 md:px-12 lg:px-24">
          <div className="text-center mb-12">
            <p className="text-xs font-bold tracking-[0.2em] uppercase text-[#FACC15] mb-4">
              Partenerii Noștri
            </p>
            <h2 className="text-2xl sm:text-3xl font-bold tracking-tight text-white">
              COLABORĂM CU LIDERI DIN INDUSTRIE
            </h2>
          </div>
          <div className="flex flex-wrap justify-center items-center gap-12 md:gap-16 lg:gap-24">
            {partners.map((partner, index) => (
              <div 
                key={index}
                className="flex items-center justify-center h-20 grayscale hover:grayscale-0 opacity-70 hover:opacity-100 transition-all duration-300"
                data-testid={`partner-${index}`}
              >
                <img 
                  src={partner.logo} 
                  alt={partner.name}
                  className="h-full max-w-[180px] object-contain brightness-0 invert hover:brightness-100 hover:invert-0 transition-all duration-300"
                />
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* About Preview */}
      <section className="py-24 md:py-32 bg-[#FAFAFA]" data-testid="about-preview-section">
        <div className="px-6 md:px-12 lg:px-24">
          <div className="grid grid-cols-1 lg:grid-cols-12 gap-12 items-center">
            <div className="lg:col-span-5">
              <p className="text-xs font-bold tracking-[0.2em] uppercase text-[#FACC15] mb-4">
                Despre Noi
              </p>
              <h2 className="text-3xl sm:text-4xl font-bold tracking-tight mb-6">
                EXPERIENȚĂ ȘI PROFESIONALISM
              </h2>
              <p className="text-base font-medium leading-relaxed text-[#737373] mb-6">
                SC SOLAR CONSTRUCT SRL este o companie cu experiență în producția și livrarea de beton readymix. Cu o flotă modernă de autobetoniere și un laborator propriu, garantăm calitatea fiecărei livrări.
              </p>
              <p className="text-base font-medium leading-relaxed text-[#737373] mb-8">
                Suntem mândri să fim partenerul de încredere al constructorilor din Focșani și împrejurimi, oferind soluții complete pentru proiecte de orice dimensiune.
              </p>
              <Button 
                asChild
                variant="outline"
                className="border-2 border-[#0A0A0A] text-[#0A0A0A] hover:bg-[#0A0A0A] hover:text-white rounded-none font-bold tracking-wider uppercase text-xs px-6"
                data-testid="about-more-btn"
              >
                <Link to="/despre">
                  Află Mai Multe
                  <ArrowRight className="ml-2 w-4 h-4" />
                </Link>
              </Button>
            </div>
            <div className="lg:col-span-7">
              <img 
                src={ABOUT_IMG} 
                alt="Echipa Solar Construct" 
                className="w-full h-[400px] lg:h-[500px] object-cover"
              />
            </div>
          </div>
        </div>
      </section>

      {/* Services Preview */}
      <section className="py-24 md:py-32 bg-white" data-testid="services-preview-section">
        <div className="px-6 md:px-12 lg:px-24">
          <div className="grid grid-cols-1 lg:grid-cols-12 gap-12">
            <div className="lg:col-span-8">
              <p className="text-xs font-bold tracking-[0.2em] uppercase text-[#FACC15] mb-4">
                Serviciile Noastre
              </p>
              <h2 className="text-3xl sm:text-4xl font-bold tracking-tight mb-8">
                CLASE DE BETON DISPONIBILE
              </h2>
              <div className="border border-[#D4D4D4]">
                <div className="grid grid-cols-3 bg-[#0A0A0A] text-white">
                  <div className="p-4 font-bold text-xs tracking-[0.1em] uppercase">Clasă</div>
                  <div className="p-4 font-bold text-xs tracking-[0.1em] uppercase border-l border-[#333]">Utilizare</div>
                  <div className="p-4 font-bold text-xs tracking-[0.1em] uppercase border-l border-[#333]">Preț/m³</div>
                </div>
                {concreteGrades.map((item, index) => (
                  <div 
                    key={index} 
                    className="grid grid-cols-3 border-t border-[#D4D4D4] hover:bg-[#FAFAFA] transition-colors"
                    data-testid={`grade-row-${item.grade}`}
                  >
                    <div className="p-4 font-bold">{item.grade}</div>
                    <div className="p-4 text-[#737373] border-l border-[#D4D4D4]">{item.description}</div>
                    <div className="p-4 font-bold text-[#FACC15] border-l border-[#D4D4D4]">{item.price} RON</div>
                  </div>
                ))}
              </div>
              <div className="mt-8">
                <Button 
                  asChild
                  className="bg-[#FACC15] text-[#0A0A0A] hover:bg-yellow-400 rounded-none font-bold tracking-wider uppercase text-xs px-6"
                  data-testid="services-calc-btn"
                >
                  <Link to="/servicii">
                    Calculator Preț
                    <ArrowRight className="ml-2 w-4 h-4" />
                  </Link>
                </Button>
              </div>
            </div>
            <div className="lg:col-span-4">
              <img 
                src={MIXER_IMG} 
                alt="Autobetonieră Solar Construct" 
                className="w-full h-full min-h-[400px] object-cover"
              />
            </div>
          </div>
        </div>
      </section>

      {/* Testimonials */}
      <section className="py-24 md:py-32 bg-[#0A0A0A]" data-testid="testimonials-section">
        <div className="px-6 md:px-12 lg:px-24">
          <p className="text-xs font-bold tracking-[0.2em] uppercase text-[#FACC15] mb-4">
            Testimoniale
          </p>
          <h2 className="text-3xl sm:text-4xl font-bold tracking-tight mb-16 text-white">
            CE SPUN CLIENȚII NOȘTRI
          </h2>
          <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
            {testimonials.map((item, index) => (
              <div 
                key={index} 
                className="border-l-2 border-[#FACC15] pl-6"
                data-testid={`testimonial-${index}`}
              >
                <p className="text-xl font-medium text-white mb-6 leading-relaxed">
                  "{item.quote}"
                </p>
                <p className="text-[#FACC15] font-bold">{item.author}</p>
                <p className="text-[#737373] text-sm">{item.company}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* CTA Section */}
      <section className="py-24 md:py-32 bg-[#FACC15]" data-testid="cta-section">
        <div className="px-6 md:px-12 lg:px-24 text-center">
          <h2 className="text-3xl sm:text-4xl font-bold tracking-tight mb-6 text-[#0A0A0A]">
            ÎNCEPE PROIECTUL TĂU ASTĂZI
          </h2>
          <p className="text-lg text-[#0A0A0A]/80 mb-8 max-w-2xl mx-auto">
            Contactează-ne pentru o ofertă personalizată. Echipa noastră este gata să îți ofere cele mai bune soluții pentru proiectul tău.
          </p>
          <div className="flex flex-col sm:flex-row gap-4 justify-center">
            <Button 
              asChild
              className="bg-[#0A0A0A] text-white hover:bg-[#171717] rounded-none font-bold tracking-wider uppercase text-sm px-8 py-6"
              data-testid="cta-phone-btn"
            >
              <a href="tel:+40722344534">
                Sună Acum: +40 722 344 534
              </a>
            </Button>
            <Button 
              asChild
              variant="outline"
              className="bg-transparent border-2 border-[#0A0A0A] text-[#0A0A0A] hover:bg-[#0A0A0A] hover:text-white rounded-none font-bold tracking-wider uppercase text-sm px-8 py-6"
              data-testid="cta-contact-btn"
            >
              <Link to="/contact">
                Vezi Locația
              </Link>
            </Button>
          </div>
        </div>
      </section>
    </div>
  );
};
